import styles from "./styles.module.css";
import { FileText } from 'lucide-react';

function Logo(){
    return (
        <div className={styles.logo}>
            <div className={styles.containerIcon}><FileText className={styles.icon} size={30}/></div>
            <div><span className={styles.logoName}>Orçamento Digital</span></div>
        </div>        
    );
}

export default Logo;